<template>
    <div>
        <template v-for="(navigationItem, a) in $store.getters.getSearchNavigationCategories">
            <p class="mb-0 caption px-4 grey white--text darken-2">{{a}}</p>
            <v-treeview
                ref="treeview"
                activatable
                :active="[activeCategory]"
                :open="openNodes"
                v-model="category"
                :items="navigationItem"
                item-key="key">
                <div slot="label" slot-scope="{ item, active }" @click.stop="setTreeCategory(item);">
                    <a :href="getCategoryUrl(item)" @click.self.prevent>
                        {{ item.name }}
                    </a>
                </div>
            </v-treeview>
        </template>
    </div>
</template>

<script>
import Mobile from '../../inc/mixins/mobile';
import Categories from "../../inc/mixins/categories";
import CategoryManager from '../../inc/managers/CategoryManager';

export default {
    data() {
        return {
            category: [],
            categoryList: [],
            openNodes: [],
            activeCategory: 'all-titles',
            currentCategoryPath: ''
        };
    },
    mixins: [Mobile, Categories],
    methods: {
        setTreeCategory(catObject) {
            let data = {
                resetPage: true,
                query: {
                    searchTerm: '',
                    category: catObject.name,
                    astmSubject: null,
                    year: this.$store.getters.getSearchNavigationCategoryNames.includes(catObject.name)
                        ? null
                        : 'Current Adoption'
                }
            };
            this.defaultSearch = '';
            EventBus.fire('update-search-data', data);
        },
        getCategoryUrl(item) {
            return this.getRoute('codes_category', { category: item.slug });
        },
        syncOpenNodes() {
            this.openNodes = [];

            // Find parent nodes containing active category as a child
            const parentCategory = this.categoryList.find(category =>
                category.children.some(child => child.slug === this.activeCategory)
            );

            if (parentCategory) {
                this.currentCategoryPath = `/codes/${parentCategory.slug}/${this.activeCategory}`;
                this.openNodes = [parentCategory.slug];
            } else {
                this.currentCategoryPath = `/codes/${this.activeCategory}`;
            }
        },
        scrollActiveItemIntoView(sendPageView = true) {
            this.$nextTick(() => {
                const activeNode = document.querySelector('.v-treeview-node--active');

                if (activeNode) {
                    activeNode.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest'
                    });

                    if (sendPageView) {
                        EventBus.fire('send-page-view', this.currentCategoryPath);
                    }
                }
            });
        },
        updateActiveCategoryFromUrl() {
            const locationParts = window.location.pathname.split("/");
            this.activeCategory = locationParts.length > 2 ? locationParts[locationParts.length - 1] : 'all-titles';
        }
    },
    created() {
        // Populate categories from CategoryManager
        this.categoryList = CategoryManager.getAllLinks(this.$store, this.sortedCategories);

        // Listen for location changes
        EventBus.listen('location:changed', () => {
            this.updateActiveCategoryFromUrl();
        });

        this.updateActiveCategoryFromUrl();

        this.$nextTick(() => {
            this.syncOpenNodes();
            this.scrollActiveItemIntoView();
        });

        this.$watch(() => this.titleSearchCategory, () => {
            this.syncOpenNodes();
            this.scrollActiveItemIntoView();
        }, { immediate: true });
    }
};
</script>
